import * as React from 'react';
import { createElement, useEffect, useState, useCallback, useImperativeHandle, createRef, } from 'react';
import { createForm } from '@formily/core';
import { FormProvider } from '@formily/react';
import { FormLayout } from '@formily/antd-mobile';
import { FormControlContext } from '../../shared';
const FormilyForm = React.forwardRef((props, ref) => {
    const { __designMode, style, componentProps, children } = props;
    const isDesign = __designMode === 'design';
    const createFormilyForm = () => {
        return createForm({
            readOnly: isDesign,
        });
    };
    const [form, setForm] = useState(() => {
        return createFormilyForm();
    });
    useImperativeHandle(ref, () => {
        return {
            form,
        };
    });
    const updateForm = useCallback(() => {
        setForm((prevForm) => {
            const prevState = prevForm.getState();
            const newForm = createFormilyForm();
            newForm.setState(prevState);
            return newForm;
        });
    }, []);
    useEffect(() => {
        if (__designMode === 'design') {
            updateForm();
        }
    }, [componentProps]);
    return (createElement(FormControlContext.Provider, { value: {
            updateForm,
        } },
        createElement(FormProvider, { form: form },
            createElement(FormLayout, Object.assign({ style: style }, componentProps), children))));
});
class FormClass extends React.Component {
    constructor() {
        super(...arguments);
        this.formRef = createRef();
    }
    get form() {
        return this.formRef.current.form;
    }
    render() {
        return createElement(FormilyForm, Object.assign({}, this.props, { ref: this.formRef }));
    }
}
export default FormClass;
